import AxiosInstance from "../instance";
import {returnValidResponse} from "../utils";
import AwesomeDebouncePromise from "awesome-debounce-promise";

const searchExposureEventsOrig = async (event: string) => {
    const response = await AxiosInstance.getInstance().get("/exposure/search-events", {
        params: {
            event
        }
    });
    return returnValidResponse(response);
};

const searchExposureEvents = AwesomeDebouncePromise(
    searchExposureEventsOrig,
    500
);

const getExposureEvent = async (event: string) => {
    const response = await AxiosInstance.getInstance().get("/exposure/search-records", {
        params: {
            event
        }
    });
    return response;
};

export {
    searchExposureEvents,
    getExposureEvent
};


// WEBPACK FOOTER //
// ./src/api/models/Exposure.ts